export const getSnippet = (lang, user_id, project_id, db_id, coll_id, region) => {

  switch (lang) {
    case "python":
      return `
<span class="keyword">from</span> <span class="module">erioon.login</span> <span class="keyword">import</span> <span  class="function">ErioonLogin</span>

<span class="variable">client</span> = <span  class="function">ErioonLogin</span>(<span class="string">"YOUR_API_KEY_HERE"</span>)

<span class="variable">database</span> = <span class="variable">client</span>[<span class="string">"${db_id}"</span>]
<span class="variable">collection</span> = <span class="variable">database</span>[<span class="string">"${coll_id}"</span>]

<span class="variable">collection</span>.<span class="function">ping</span>()
`;

    case "javascript":
      return `
<span class="comment">// API Key and URL</span>
const API_KEY = <span class="string">"YOU_API_KEY_HERE"</span>;
const url = <span class="string">"https://api.erioon.com/${user_id}/${project_id}/${db_id}/${region}/${coll_id}/connection_ping"</span>;

<span class="comment">// Headers with Bearer token</span>
const headers = {
  <span class="string">"Authorization"</span>: <span class="string">"Bearer {API_KEY}"</span>,
  <span class="string">"Content-Type"</span>: <span class="string">"application/json"</span>
};

<span class="comment">// Make the request using fetch</span>
fetch(url, {
  method: <span class="string">"GET"</span>,
  headers: headers
})
  .then(response => response.json())
  .then(data => console.log(data))
  .catch(error => console.error('Error:', error));
`;

    case "curl":
      return `
<span class="comment"># cURL request with Bearer token</span>
curl -X GET <span class="string">"https://api.erioon.com/${user_id}/${project_id}/${db_id}/${region}/${coll_id}/connection_ping"</span> \\
     -H <span class="string">"Authorization: Bearer API_KEY"</span> \\
     -H <span class="string">"Content-Type: application/json"</span>
`;

    default:
      return "Language not supported!";
  }
};
